
$(document).ready(function () {

    var description = $('#product-description');
  var readMoreLink = $('.readmore');

if (description.text().trim().length <= 27) {
    readMoreLink.hide();
  description.css({ 'height': 'auto', 'overflow': 'hidden' });
} else if (description.text().trim().length <= 50) {
    readMoreLink.hide();
    description.css({ 'height': 'auto', 'overflow': 'hidden' });
} else if (description.text().trim().length <= 90) {
    readMoreLink.hide();
    description.css({ 'height': 'auto', 'overflow': 'hidden' });
} else {
    readMoreLink.show();
}

  
  $('.readmore').click(function (event) {
    
      event.preventDefault();
    
      var description = document.querySelector('#product-description');
      console.log(description.style.height)
      if (description.style.height === ''){
        description.style.height = 'auto';
      } else if (description.style.height === 'auto'){
        description.style.height = '';
      }
      else{
        description.style.height = '92px';
         $('html, body').animate({
              scrollTop: $('#product-description').offset().top
          }, 'slow');
      }
      $(this).text($(this).text() == 'Read less...' ? 'Read More...' : 'Read less...');
  });
});

